export default {
    excess: 'Смањење одговорности',
    security: 'Сигурносни депозит',
    fuel_policy: 'Политика горива',
    like_for_like: 'Колико на почетку толико на крају',
    full_to_full: 'Са пуним резервоаром на почетку и на крају',
    mileage: 'Миљажа: {mileage} миља по изнајмљивању',
    unlimited_mileage: 'Неограничена миљажа',
    non_refundable: 'Не може се вршити поврат новца',
    free_cancellation_until: 'Бесплатно отказивање до {date}',
    cancellation_with_terms: 'Отказивање {0} у складу са ',
    t_c_text: 'Услови коришћења',
    two_free_extras: 'Два бесплатна додатка на наплату',
    glass_tyres_covered: 'Стакло и гуме су покривени'
}
